import React from 'react';
import { Box, Stack, SxProps, Theme } from '@mui/material';
import { TextBone } from '../../atoms/TextBone/TextBone';

export interface ToolbarBoneProps {
    /** Largeur du contenu gauche */
    contentLeftWidth?: string;
    /** Largeur du contenu droit */
    contentRightWidth?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const ToolbarBone: React.FunctionComponent<ToolbarBoneProps> = function ({
    contentLeftWidth = '600px',
    contentRightWidth = '300px',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: 2,
                width: '100%',
                padding: '16px',
                ...sx,
            }}
        >
            <Stack
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    height: '95%',
                    gap: 1,
                }}
            >
                <TextBone
                    textVariant="h6"
                    sx={{
                        fontWeight: '500',
                        fontSize: '24px',
                        width: contentLeftWidth,
                    }}
                />
                <TextBone
                    textVariant="h6"
                    sx={{ fontWeight: '500', fontSize: '24px', width: contentRightWidth }}
                />
            </Stack>
        </Box>
    );
};
